import { FormControlLabel } from '@material-ui/core';
import { withStyles } from '@material-ui/styles';
import { flowRight } from 'lodash';
import React, { useMemo, useState } from 'react';
import { connect } from 'react-redux';

import checkNumberData from '../../../utils/checkNumberData';
import { createValueLabel, mapValue } from '../actions/dataActions';
import styles from '../styles/generalData';
import CustomTitle from './CustomTitle';
import Optional from '../../../utils/optional';
import { formatDateForSchedule } from '../../../utils/formatDate';
import Product from './Product';
import CustomSwitch from '../../../partials/CustomSwitch';
import { isArray } from '../../../utils/isDefined';

const CarrierProducts = ({
  classes,
  carrierData = {},
  fromRightPanel = false,
  rightPanelData = {}
}) => {
  const [openProducts, setOpenProducts] = useState({});

  const { isDataExist, data } = useMemo(() => {
    return checkNumberData({
      numberData: carrierData,
      rightPanelData,
      fromRightPanel
    });
  }, [carrierData, rightPanelData, fromRightPanel]);

  const products = isArray(data) ? data : [];
  const areAllProductsOpen =
    products.length > 0 &&
    products.every((prod, index) => Boolean(openProducts[index]));

  const toggleAllProducts = checked => {
    setOpenProducts(
      products.reduce((obj, prod, index) => ({ ...obj, [index]: checked }), {})
    );
  };

  return (
    <div className={classes.root}>
      <CustomTitle
        title="PRODUCT"
        isDataExist={isDataExist}
        dotsMenu
        menuComponent={
          <FormControlLabel
            label="Expand all"
            onClick={event => event.stopPropagation()}
            classes={{
              root: classes.expandAllControl,
              label: classes.expandAllLabel
            }}
            style={{ margin: 0 }}
            control={
              <CustomSwitch
                checked={areAllProductsOpen}
                handleChange={event => toggleAllProducts(event.target.checked)}
              />
            }
          />
        }
      >
        {isDataExist && (
          <div>
            {products.map((el, index) => (
              <Product
                product={el}
                key={index}
                isOpen={Boolean(openProducts[index])}
                onToggle={isOpen =>
                  setOpenProducts(previous => ({
                    ...previous,
                    [index]: isOpen
                  }))
                }
              />
            ))}
          </div>
        )}
      </CustomTitle>
    </div>
  );
};

const mapStatesToProps = ({ checkNumber, rightPanel, auth }) => {
  return {
    carrierData: checkNumber?.carrierData?.products,
    rightPanelData: rightPanel?.number?.carrierData?.products,
    lang: auth.lang
  };
};

export default flowRight(
  connect(mapStatesToProps),
  withStyles(styles)
)(CarrierProducts);
